export const environment = {
  production: true,
  baseServerURL: 'https://qa.server.trobbit.com/api/v1',
  assetURL: 'https://qa.server.trobbit.com',
  socketsURL: 'https://qa.server.trobbit.com',
  baseServerURLOld: 'http://localhost:1337/api/v1',
  assetURLOld: 'http://localhost:3000',
  secretKey: 'trobbit2020',
  vapidKey: 'BOk5FfnlOMm5u9ZJ8ZtG4Y6mneBuZlfc9zrotkY60b0rLjkWTpssp-LFwNfmDQYh9MWGe4UfpVxWk--cH_5b-w8',
  firebaseConfig: {
    apiKey: 'AIzaSyA0B829SHtPE9ZNjHm8fBYwZSgo9vDCpCM',
    authDomain: 'calendar-95a50.firebaseapp.com',
    databaseURL: '',
    projectId: 'calendar-95a50',
    storageBucket: 'l',
    messagingSenderId: ''
  }
};
